import axiosInstance from "../interceptor/instance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_USER}/permission`;

export const getTempRequests = async (params) => {
  const response = await axiosInstance.get(
    baseUrl,
    { params: params }
  );
  return response.data;
};

export const approveUser = async (id) => {
  const response = await axiosInstance.patch(
    `${baseUrl}/${id}`,
    {
      status: "approved",
    }
  );
  return response.data;
};
export const rejectUser = async (id) => {
  const response = await axiosInstance.patch(
    `${baseUrl}/${id}`,
    {
      status: "rejected",
      reason: "User not Allowed",
    }
  );
  return response.data;
};

export const patchRejectReason = async ({ reason, id }) => {
  const response = await axiosInstance.patch(
    `${baseUrl}/${id}`,
    {
      reason: reason,
    }
  );
  return response.data;
};
